import { defineComponent as _defineComponent } from 'vue'
import { computed, useRoute } from "@nuxtjs/composition-api";

import { logoLayouts } from "@/types";
import { truncateWithEllipsis } from "@/utils/transform/text";

// Calculated by our top resolution being 390x844

export default /*#__PURE__*/_defineComponent({
  __name: 'SplashScreen',
  setup(__props) {

const MAX_CHAR_LIMIT_FOR_DISPLAY_NAME = 20;

const route = useRoute();

const displayName = computed(() =>
  truncateWithEllipsis(route.value.params.displayName ?? "", MAX_CHAR_LIMIT_FOR_DISPLAY_NAME),
);

return { __sfc: true,MAX_CHAR_LIMIT_FOR_DISPLAY_NAME, route, displayName, logoLayouts }
}

})